"use client";

import React, { createContext, useEffect, useState } from "react";

export const TimezoneContext = createContext<string | null>(null);

export const TimezoneProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [timezone, setTimezone] = useState<string | null>(null);

  useEffect(() => {
    const detectedTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Save to cookie and localStorage
    localStorage.setItem("user_timezone", detectedTZ);
    document.cookie = `user_timezone=${detectedTZ}; path=/; max-age=${
      60 * 60 * 24 * 7
    }; SameSite=Strict`;

    setTimezone(detectedTZ);
  }, []);

  return (
    <TimezoneContext.Provider value={timezone}>
      {children}
    </TimezoneContext.Provider>
  );
};
